import { Table } from "semantic-ui-react";
import { TemplateField } from "./EditPermitTemplateForm";
import GridActionButton from "./GridActionButton";
import { StateKeyList } from "../models/StateKey";

const fieldTypeLabels: Record<string, string> = {
  Text: "Text",
  Number: "Number",
  Boolean: "Boolean",
  Date: "Date",
};

/** Lookup from StateKey to display name, built from StateKeyList. */
const stateKeyNames: Record<string, string> = Object.fromEntries(
  Object.values(StateKeyList).map((s) => [s.key, s.name]),
);

interface Props {
  fields: TemplateField[];
  onEditField: (index: number) => void;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  onRemoveField: (index: number) => void;
}

const PermitFieldsGrid = ({ fields, onEditField, onMoveUp, onMoveDown, onRemoveField }: Props) => {
  const formatEditableStages = (field: TemplateField): string => {
    if (!field.editableAtStages || field.editableAtStages.length === 0) return "—";
    return field.editableAtStages.map((s) => stateKeyNames[s] ?? s).join(", ");
  };

  const formatRequiredForState = (field: TemplateField): string => {
    if (!field.requiredForState) return "—";
    return stateKeyNames[field.requiredForState] ?? field.requiredForState;
  };

  const renderRows = () => {
    return fields.map((field, index) => (
      <Table.Row key={index}>
        <Table.Cell>
          {field.label || <span style={{ color: "#999", fontStyle: "italic" }}>not set</span>}
          <GridActionButton
            rowId={index}
            items={[
              { key: "edit", icon: "edit", content: "Edit", callback: onEditField },
              { key: "move-up", icon: "arrow up", content: "Move Up", callback: onMoveUp, disabled: index === 0 },
              { key: "move-down", icon: "arrow down", content: "Move Down", callback: onMoveDown, disabled: index === fields.length - 1 },
              { key: "remove", icon: "trash", content: "Remove", callback: onRemoveField },
            ]}
          />
        </Table.Cell>
        <Table.Cell>{fieldTypeLabels[field.fieldType] ?? field.fieldType}</Table.Cell>
        <Table.Cell>{formatRequiredForState(field)}</Table.Cell>
        <Table.Cell>{formatEditableStages(field)}</Table.Cell>
      </Table.Row>
    ));
  };

  return (
    <Table basic="very" compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Label</Table.HeaderCell>
          <Table.HeaderCell>Type</Table.HeaderCell>
          <Table.HeaderCell>Required For</Table.HeaderCell>
          <Table.HeaderCell>Editable At</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{renderRows()}</Table.Body>
      <Table.Footer>
        <Table.Row textAlign="right">
          <Table.HeaderCell colSpan="4"></Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default PermitFieldsGrid;

